window.silesia = window.silesia || {};
window.silesia.layout = window.silesia.layout || {};

window.silesia.layout.commentList = function() {
    return {
        commentFormContainerSelector: '.tpl-comments__form-container',
        newCommentContainerSelector: '.tpl-comments__add-form-container',
        replyToContainerSelector: '.tpl-comments__item-reply-to',
        hiddenElements:[],
    
        resetReplyForm:function() {
            var commentFormContainerElement = document.querySelector(this.commentFormContainerSelector);
            commentFormContainerElement.querySelector('input[name=parent]').value = 0;
    
            for(var el of document.querySelectorAll(this.replyToContainerSelector)) {
                el.style.display = '';
            }

            for(var el of this.hiddenElements) {
                el.style.display = '';
            }
        },
        
        showReplyForm:function(commentId,hideElement=null) {
            this.resetReplyForm();
    
            //Fix - zapobiega skokom strony
            var currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    
            if(this.$refs['comment-'+commentId]) {
                var commentFormContainerElement = document.querySelector(this.commentFormContainerSelector);
                /* commentFormContainerElement.querySelector('input[name=parent]').value = commentId; */
                Alpine.$data(commentFormContainerElement.querySelector('form')).parent = commentId
                this.$refs['comment-'+commentId].append(commentFormContainerElement);
            }
    
            if(hideElement) {
                hideElement.style.display = 'none';
                this.hiddenElements.push(hideElement);
            }
    
            window.pageYOffset ? (window.pageYOffset=currentScroll) : (document.documentElement.scrollTop=currentScroll);
        },
    
        newCommentForm:function() {
            this.resetReplyForm();
    
            //Fix - zapobiega skokom strony
            var currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    
            var commentFormContainerElement = document.querySelector(this.commentFormContainerSelector);
            //commentFormContainerElement.querySelector('input[name=parent]').value = 0;
            window.Alpine.$data(commentFormContainerElement).parent = 0;
    
            var newCommentContainerElement = document.querySelector(this.newCommentContainerSelector);
            newCommentContainerElement.append(commentFormContainerElement);
    
            window.pageYOffset ? (window.pageYOffset=currentScroll) : (document.documentElement.scrollTop=currentScroll);
        }
    }
}




if(document.querySelector('*[x-data-lazy*="window.silesia.layout.commentList"]')) {
    for(var el of document.querySelectorAll('*[x-data-lazy*="window.silesia.layout.commentList"]')) {
        el.setAttribute('x-data', el.getAttribute('x-data-lazy'));
        el.removeAttribute('x-data-lazy');
    };
}